export function StatCard({ icon, label, value, badge, gold }) {
  return (
    <div
      className="bg-surface border-4 border-on-background flex flex-col gap-3 p-6"
      style={{ boxShadow: gold ? '6px 6px 0px 0px #d4af37' : '6px 6px 0px 0px var(--neo-border-color)' }}
    >
      <div className="flex items-center justify-between">
        <div className={`w-10 h-10 border-4 border-on-background flex items-center justify-center ${gold ? 'bg-primary-container' : 'bg-surface-container'}`}>
          <span className="material-symbols-outlined text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>{icon}</span>
        </div>
        {badge && (
          <span className="font-bold text-[9px] uppercase tracking-[0.16em] px-2 py-1 border-2 border-on-background/20 bg-surface-container-low text-on-surface-variant">
            {badge}
          </span>
        )}
      </div>
      <div>
        <p className="font-extrabold text-[36px] leading-none tracking-tight">{value ?? '—'}</p>
        <p className="font-bold text-[10px] uppercase tracking-[0.14em] text-on-surface-variant mt-1">{label}</p>
      </div>
    </div>
  )
}
